import React, { useCallback, useContext } from 'react';
import useApiCall from '../../../services/useApiCall';
import useAPI from '../../../services/useAPI';
import ConfirmDeleteModal from '../../Modals/ConfirmDeleteModal';
import { useTranslation } from '../../../localization/useTranslation';
import { format } from '../../../utils/string';
import AlertContext from 'services/AlertContext';


const DeleteAlarm = ({ confirmDeleteItem, onDelete, onCancel }) => {
  const api = useAPI();
  const T = useTranslation();
  const { addErrorAlert } = useContext(AlertContext);

  const [deleteAlarmDef, isDeleting] = useApiCall({
    apiCall: api.core.deleteAlarm,
    onSuccess: useCallback(() => {
      onDelete(confirmDeleteItem);
    }, [confirmDeleteItem, onDelete]),
    onError: useCallback((error) => {
      addErrorAlert(format(T.admin.alarms.deleteFailed, error));
    }, [T.admin.alarms.deleteFailed, addErrorAlert])
  });

  const onConfirm = useCallback((alarmDef) => {
    deleteAlarmDef(alarmDef.id);
  }, [deleteAlarmDef]);

  return (
    <>
      <ConfirmDeleteModal
        isLoading={isDeleting}
        onConfirm={onConfirm}
        item={confirmDeleteItem}
        itemName={`${confirmDeleteItem?.name}` ?? T.common.noname}
        onCancel={onCancel}
      />
    </>
  );
};

export default DeleteAlarm;
